import { mongoOdLen } from '../config';

export const mongoId = (id) =>
  id && typeof id === 'string' && id.length === mongoOdLen ? id : '';
